import { DataTablePagination, DataTableSearch, Typography, DataTable } from '@ui/components';
import { VehicleTableDataDto } from '@interfaces/models';
import { useTranslation, Trans } from 'react-i18next';
import { useState } from 'react';

import { RemoveVehicleDialog } from '../remove-vehicle-dialog/remove-vehicle-dialog';
import { EditVehicleDrawer } from '../edit-vehicle-drawer/edit-vehicle-drawer';
import { useImportVehiclesTable } from './use-import-vehicles-table';

export const ImportVehiclesTable = () => {
  const { t } = useTranslation();

  const [isEditVehicleDrawerOpen, setIsEditVehicleDrawerOpen] = useState(false);
  const [isRemoveVehicleDialogOpen, setIsRemoveVehicleDialogOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState<VehicleTableDataDto>();

  const { table, globalFilter, isLoading, columnsLength, totalItems, refetchTable } =
    useImportVehiclesTable({
      onEditVehicle: (vehicle: VehicleTableDataDto) => {
        setIsEditVehicleDrawerOpen(true);
        setSelectedVehicle(vehicle);
      },
      onRemoveVehicle: (vehicle: VehicleTableDataDto) => {
        setIsRemoveVehicleDialogOpen(true);
        setSelectedVehicle(vehicle);
      },
    });

  return (
    <div className="bg-table-background rounded-lg overflow-hidden mb-8">
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumMedium">
          {t('ONBOARDING.IMPORT_VEHICLES.TABLE_TOTAL_VEHICLES', { count: totalItems })}
        </Typography>

        <div className="ml-auto flex items-center gap-4">
          <DataTableSearch
            placeholder={t('ONBOARDING.IMPORT_VEHICLES.TABLE_SEARCH_PLACEHOLDER')}
            onChange={table.setGlobalFilter}
            value={globalFilter}
          />

          <DataTablePagination
            pageIndex={table.getState().pagination.pageIndex}
            pageSize={table.getState().pagination.pageSize}
            prevPageDisabled={!table.getCanPreviousPage()}
            nextPageDisabled={!table.getCanNextPage()}
            prevPage={() => table.previousPage()}
            nextPage={() => table.nextPage()}
            totalRows={totalItems}
          />
        </div>
      </div>
      <DataTable
        noResultsComponent={
          <Typography variant="labelMediumBook">
            <Trans i18nKey="ONBOARDING.IMPORT_VEHICLES.TABLE_NO_RESULTS" />
          </Typography>
        }
        className="max-h-[60vh] overflow-auto"
        columnsLength={columnsLength}
        isLoading={isLoading}
        table={table}
      />

      {selectedVehicle && (
        <EditVehicleDrawer
          onClose={(data) => {
            if (data?.hasBeenModified) {
              refetchTable();
            }

            setIsEditVehicleDrawerOpen(false);
          }}
          showRemoveVehicleDialog={() => setIsRemoveVehicleDialogOpen(true)}
          isOpen={isEditVehicleDrawerOpen}
          data={selectedVehicle}
        />
      )}

      {selectedVehicle && (
        <RemoveVehicleDialog
          onClose={(data) => {
            if (data?.hasBeenModified) {
              refetchTable();
              setIsEditVehicleDrawerOpen(false);
            }

            setIsRemoveVehicleDialogOpen(false);
          }}
          assignedEmployees={selectedVehicle.employees || []}
          isOpen={isRemoveVehicleDialogOpen}
          vehicleId={selectedVehicle.id}
        />
      )}
    </div>
  );
};
